import React, { useMemo } from "react";
import { BENEFIT_TYPE_DETAILS } from "../../../assests/data/results-header-text";
import ComparisonIcon from "./ComparisonIcon";
import { currencyFormatter } from "../../../shared/utils/formatters";
import classes from "./Card.module.css";

const Card = ({
  card,
  isHovered,
  onMouseEnter,
  onMouseLeave,
  onClick,
  comparisonArray,
}) => {
  const { label, suffix, colour } = BENEFIT_TYPE_DETAILS[card.benefitType];

  const cardClasses = useMemo(() => {
    return `${classes.card} ${classes[colour]} ${
      isHovered ? `${classes[`${colour}_hovered`]} ${classes.hovered}` : ""
    }`;
  }, [isHovered, colour]);

  const sumValues = useMemo(() => {
    return Object.values(card.values).reduce((acc, value) => acc + value, 0);
  }, [card.values]);

  return (
    <section
      className={cardClasses}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
      tabIndex="0"
    >
      <div className={classes.cardBody}>
        <div>
          <p className={classes.title} id={`card-title-${card.benefitType}`}>
            {label}:
          </p>
          <p>
            <span className={classes.value}>
              {currencyFormatter(sumValues)}
            </span>
            <span className={classes.suffix}>{suffix}</span>
          </p>
        </div>
        <ComparisonIcon comparisonArray={comparisonArray} aria-hidden="true" />
      </div>
    </section>
  );
};

export default React.memo(Card);
